import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import FSWCalculatorView from '../views/FSWCalculatorView.vue'
import IELTSConverterView from '../views/IELTSConverterView.vue'
import ProcessingTimeView from '../views/ProcessingTimeView.vue'
import AboutView from '../views/AboutView.vue'
import ImmigrationView from '../views/ImmigrationView.vue'
import VisaView from '../views/VisaView.vue'
import PRCardView from '../views/PRCardView.vue'
import AppealView from '../views/AppealView.vue'
import StudyView from '../views/StudyView.vue'
import NewsView from '../views/NewsView.vue'
import ContactView from '../views/ContactView.vue'
import PRCardApplicationView from '../views/prcard/PRCardApplicationView.vue'
import CitizenshipApplicationView from '../views/prcard/CitizenshipApplicationView.vue'

// 导入EE快速通道相关组件
import EEView from '../views/immigration/EEView.vue'
import FSWView from '../views/immigration/FSWView.vue'
import CECView from '../views/immigration/CECView.vue'
import FSTView from '../views/immigration/FSTView.vue'

// 访问签证相关组件
import VisitorVisaView from '../views/visa/VisitorVisaView.vue'
import SuperVisaView from '../views/visa/SuperVisaView.vue'
import BusinessVisitorVisaView from '../views/visa/BusinessVisitorVisaView.vue'
import StudyVisaView from '../views/visa/StudyVisaView.vue'
import ExtensionRestorationView from '../views/visa/ExtensionRestorationView.vue'
import SDSView from '../views/visa/SDSView.vue'
import VisitorToStudyView from '../views/visa/VisitorToStudyView.vue'

import SchoolIntroView from '../views/study/SchoolIntroView.vue'
import SchoolApplicationView from '../views/study/SchoolApplicationView.vue'
import DocumentGuidanceView from '../views/study/DocumentGuidanceView.vue'
import IELTSTrainingView from '../views/study/IELTSTrainingView.vue'
import InterviewGuidanceView from '../views/study/InterviewGuidanceView.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/fsw-calculator',
    name: 'fsw-calculator',
    component: FSWCalculatorView
  },
  {
    path: '/ielts-converter',
    name: 'ielts-converter',
    component: IELTSConverterView
  },
  {
    path: '/processing-time',
    name: 'processing-time',
    component: ProcessingTimeView
  },
  {
    path: '/prcard/application',
    name: 'prcard-application',
    component: PRCardApplicationView
  },
  {
    path: '/prcard/citizenship',
    name: 'citizenship-application',
    component: CitizenshipApplicationView
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView,
    children: [
      {
        path: 'company',
        name: 'company',
        component: () => import('../views/about/CompanyView.vue')
      },
      {
        path: 'why-us',
        name: 'why-us',
        component: () => import('../views/about/WhyUsView.vue')
      }
    ]
  },
  {
    path: '/immigration',
    name: 'immigration',
    component: ImmigrationView,
  },
  {
    path: '/immigration/suv',
    name: 'suv',
    component: () => import('../views/immigration/SUVView.vue')
  },
  {
    path: '/immigration/self-employed',
    name: 'self-employed',
    component: () => import('../views/immigration/SelfEmployedView.vue')
  },
  {
    path: '/immigration/rnip',
    name: 'rnip',
    component: () => import('../views/immigration/RNIPView.vue')
  },
  {
    path: '/immigration/afip',
    name: 'afip',
    component: () => import('../views/immigration/AFIPView.vue')
  },
  {
    path: '/immigration/aip',
    name: 'aip',
    component: () => import('../views/immigration/AIPView.vue')
  },
  {
    path: '/immigration/caregivers',
    name: 'aip',
    component: () => import('../views/immigration/CaregiversView.vue')
  },
  {
    path: '/immigration/ee-update',
    name: 'ee-update',
    component: () => import('../views/immigration/EEUpdateView.vue')

  },
  {
    path: '/immigration/home-care-worker',
    name: 'home-care-worker',
    component: () => import('../views/immigration/HomeCareWorkerView.vue')

  },
  {
    path: '/visa',
    name: 'visa',
    component: VisaView
  },
  // 工作签证相关路由
  {
    path: '/visa/work-permit',
    name: 'work-permit',
    component: () => import('../views/visa/WorkPermitView.vue')
  },
  {
    path: '/visa/lmia-work-permit',
    name: 'lmia-work-permit',
    component: () => import('../views/visa/LMIAWorkPermitView.vue')
  },
  {
    path: '/visa/spouse-open-work-permit',
    name: 'spouse-open-work-permit',
    component: () => import('../views/visa/SpouseOpenWorkPermitView.vue')
  },
  {
    path: '/visa/pgwp',
    name: 'pgwp',
    component: () => import('../views/visa/PGWPView.vue')
  },
  {
    path: '/visa/coop-work-permit',
    name: 'coop-work-permit',
    component: () => import('../views/visa/CoopWorkPermitView.vue')
  },
  {
    path: '/visa/bowp',
    name: 'bowp',
    component: () => import('../views/visa/BOWPView.vue')
  },
  {
    path: '/visa/imp',
    name: 'imp',
    component: () => import('../views/visa/IMPView.vue')
  },
  {
    path: '/visa/ict',
    name: 'ict',
    component: () => import('../views/visa/ICTView.vue')
  },
  {
    path: '/visa/hk-graduate-work-permit',
    name: 'hk-graduate-work-permit',
    component: () => import('../views/visa/HKGraduateWorkPermitView.vue')
  },
  // 特殊证件申请相关路由
  {
    path: '/visa/reconsideration',
    name: 'reconsideration',
    component: () => import('../views/visa/ReconsiderationView.vue')
  },
  {
    path: '/visa/prtd',
    name: 'prtd',
    component: () => import('../views/visa/PRTDView.vue')
  },
  {
    path: '/visa/trp',
    name: 'trp',
    component: () => import('../views/visa/TRPView.vue')
  },
  // 学习签证相关路由
  {
    path: '/visa/study',
    name: 'study',
    component: StudyVisaView
  },
  {
    path: '/visa/extension-restoration',
    name: 'extension-restoration',
    component: ExtensionRestorationView
  },
  {
    path: '/visa/sds',
    name: 'sds',
    component: SDSView
  },
  {
    path: '/visa/visitor-to-study',
    name: 'visitor-to-study',
    component: VisitorToStudyView
  },
  // 访问签证相关路由
  {
    path: '/visa/trv',
    name: 'trv',
    component: () => import('../views/visa/TRVView.vue')
  },
  {
    path: '/visa/visitor',
    name: 'visitor',
    component: VisitorVisaView
  },
  {
    path: '/visa/super',
    name: 'super',
    component: SuperVisaView
  },
  {
    path: '/visa/business',
    name: 'business',
    component: BusinessVisitorVisaView
  },
  {
    path: '/prcard',
    name: 'prcard',
    component: PRCardView
  },
  {
    path: '/appeal',
    name: 'appeal',
    component: AppealView,
  },
  {
    path: '/appeal/family',
    name: 'family-appeal',
    component: () => import('../views/appeal/FamilyAppealView.vue')
  },
  {
    path: '/appeal/residency',
    name: 'residency-appeal',
    component: () => import('../views/appeal/ResidencyAppealView.vue')
  },
  {
    path: '/appeal/deportation',
    name: 'deportation-appeal',
    component: () => import('../views/appeal/DeportationAppealView.vue')
  },
  {
    path: '/appeal/refugee',
    name: 'refugee-appeal',
    component: () => import('../views/appeal/RefugeeAppealView.vue')
  },
  {
    path: '/appeal/prra',
    name: 'prra',
    component: () => import('../views/appeal/PRRAView.vue')
  },
  {
    path: '/study',
    name: 'study',
    component: StudyView
  },
  {
    path: '/news',
    name: 'news',
    component: NewsView
  },
  {
    path: '/contact',
    name: 'contact',
    component: ContactView
  },
  // EE快速通道相关路由
  {
    path: '/immigration/ee',
    name: 'ee',
    component: EEView
  },
  {
    path: '/immigration/fsw',
    name: 'fsw',
    component: FSWView
  },
  {
    path: '/immigration/cec',
    name: 'cec',
    component: CECView
  },
  {
    path: '/immigration/fst',
    name: 'fst',
    component: FSTView
  },
  // 安省省提名OINP相关路由
  {
    path: '/immigration/oinp',
    name: 'oinp',
    component: () => import('../views/immigration/OINPView.vue')
  },
  {
    path: '/immigration/employer-sponsor',
    name: 'employer-sponsor',
    component: () => import('../views/immigration/EmployerSponsorView.vue')
  },
  {
    path: '/immigration/graduate',
    name: 'graduate',
    component: () => import('../views/immigration/GraduateView.vue')
  },
  {
    path: '/immigration/skilled-worker',
    name: 'skilled-worker',
    component: () => import('../views/immigration/SkilledWorkerView.vue')
  },
  {
    path: '/immigration/entrepreneur',
    name: 'entrepreneur',
    component: () => import('../views/immigration/EntrepreneurView.vue')
  },
  // 香港居民特殊通道移民相关路由
  {
    path: '/immigration/hk-graduate',
    name: 'hk-graduate',
    component: () => import('../views/immigration/HKGraduateView.vue')
  },
  {
    path: '/immigration/hk-work-exp',
    name: 'hk-work-exp',
    component: () => import('../views/immigration/HKWorkExpView.vue')
  },
  // 家庭团聚移民相关路由
  {
    path: '/immigration/family-reunion',
    name: 'family-reunion',
    component: () => import('../views/immigration/FamilyReunionView.vue')
  },
  {
    path: '/immigration/spouse-children',
    name: 'spouse-children',
    component: () => import('../views/immigration/SpouseChildrenView.vue')
  },
  {
    path: '/immigration/parents-grandparents',
    name: 'parents-grandparents',
    component: () => import('../views/immigration/ParentsGrandparentsView.vue')
  },
  {
    path: '/immigration/single-sponsor',
    name: 'single-sponsor',
    component: () => import('../views/immigration/SingleSponsorView.vue')
  },
  {
    path: '/study/school-intro',
    name: 'SchoolIntro',
    component: SchoolIntroView
  },
  {
    path: '/study/school-application',
    name: 'SchoolApplication',
    component: SchoolApplicationView
  },
  {
    path: '/study/document-guidance',
    name: 'DocumentGuidance',
    component: DocumentGuidanceView
  },
  {
    path: '/study/ielts-training',
    name: 'IELTSTraining',
    component: IELTSTrainingView
  },
  {
    path: '/study/interview-guidance',
    name: 'InterviewGuidance',
    component: InterviewGuidanceView
  }
]

const router = new VueRouter({
  routes
})

export default router
